var PubSub = require("underpub-js");

var contentWithTimeline = function(options) {
  this.options = {
    $el: false,
  };

  $.extend(true, this.options, options);
};

contentWithTimeline.prototype.init = function() {
  var self = this;

  this.options.$el.find(".timeline-item").each(function() {
    var timelinePopupCloseTimeout;
    var timelinePopupOpenTimeout;

    $(this).hover(
      // handler mouse in
      function() {
        window.clearTimeout(timelinePopupCloseTimeout);

        // get the related popup
        var $relatedPopup = $(this).find(".timeline-popup-wrapper");

        self.adjustPopupPosition($(this), $relatedPopup);

        timelinePopupOpenTimeout = window.setTimeout(function() {
          // if there are any items that haven't been hidden, hide them before showing this one
          self.options.$el
            .find(".timeline-popup-wrapper.active")
            .removeClass("active")
            .addClass("no-longer-shown");
          // show the related popup
          $relatedPopup.removeClass("no-longer-shown").addClass("active");
        }, 200);
      },
      // handler mouse out
      function() {
        window.clearTimeout(timelinePopupOpenTimeout);

        // get the related popup
        var $relatedPopup = $(this).find(".timeline-popup-wrapper");

        timelinePopupCloseTimeout = window.setTimeout(function() {
          $relatedPopup.removeClass("active").addClass("no-longer-shown");
        }, 250);
      },
    );
  });

  this.adjustAllPopups();

  PubSub.subscribe("resized", function() {
    self.adjustAllPopups();
  });
};

contentWithTimeline.prototype.adjustAllPopups = function() {
  var self = this;

  this.options.$el.find(".timeline-item").each(function() {
    var $relatedPopup = $(this).find(".timeline-popup-wrapper");
    self.adjustPopupPosition($(this), $relatedPopup);
  });
};

contentWithTimeline.prototype.adjustPopupPosition = function(
  button,
  relatedPopup,
) {
  var self = this;

  // reset the popups position
  relatedPopup.css("bottom", "0px");
  relatedPopup.css("left", "auto");
  relatedPopup.find(".down-arrow").css("left", "");

  // position the related popup
  // bottom
  var buttonHeight = button.outerHeight();
  var popupBottom = buttonHeight - 3; // subtract 3 for border offset on bottom
  relatedPopup.css("bottom", popupBottom + "px");

  // left
  var popupWidth = relatedPopup.width();
  var buttonWidth = button.width();
  var popupLeft = buttonWidth / 2 - popupWidth / 2;
  relatedPopup.css("left", popupLeft + "px");

  // check if current left position puts item out of bounds, and if it does then move it over
  var parentRect = self.options.$el[0].getBoundingClientRect();
  var popupRect = relatedPopup[0].getBoundingClientRect();

  // note: items are limited to 80vw so they'll never be both too far right and too far left

  // if too far right
  if (parentRect.right - 16 < popupRect.right) {
    // adjust popup to bump onto screen
    var rightDiff = popupRect.right - parentRect.right + 16; // add 16px for some buffer from edge
    popupLeft -= rightDiff;

    // adjust arrow to point at button
    var buttonLeft = relatedPopup.width() / 2 - 12 + rightDiff;

    relatedPopup.find(".down-arrow").css("left", buttonLeft + "px");
  }

  // if too far left

  if (popupRect.left < 16) {
    // adjust popup to bump onto screen
    var leftDiff = popupRect.left * -1 + 16;
    popupLeft += leftDiff;

    // adjust arrow to point at button
    var buttonLeft = relatedPopup.width() / 2 - 12 - leftDiff;

    relatedPopup.find(".down-arrow").css("left", buttonLeft + "px");
  }

  relatedPopup.css("left", popupLeft + "px");
};

module.exports = contentWithTimeline;
